import { render, staticRenderFns } from "./ImageEditModal.vue?vue&type=template&id=566278e2&"
import script from "./ImageEditModal.vue?vue&type=script&lang=ts&"
export * from "./ImageEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports